export function replaceDimensionsInUrl(url: string) {
  const lastSlashIndex = url?.lastIndexOf("/");
  if (
    lastSlashIndex !== -1 &&
    (url?.includes("{w}x{h}bb.jpg") || url?.includes("{w}x{h}ac.jpg"))
  ) {
    const baseUrl = url?.substring(0, lastSlashIndex);
    const newUrl = `${baseUrl}/200x200bb.jpg`;
    return newUrl;
  }
  return url;
}

// const originalUrl = 'https://example.com/images/{w}x{h}bb.jpg';
// const modifiedUrl = replaceDimensionsInUrl(originalUrl);
// console.log(modifiedUrl);

export const getCurrentDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0'); // Ensures two digits
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const year = today.getFullYear();

  return `${day}/${month}/${year}`;
};
